import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { reduxForm } from 'redux-form';
import { orderTypes, buyValue } from '../../constants/sendOrder/orderEntryFormConstants';
import ReportBlockTradeComponent from './ReportBlockTradeComponent';
import instrumentPositionSelector, { selectedInstrumentSelector, instrumentSelectorInstruments } from '../../redux/selectors/instrumentPositionSelectors';
import { MODAL_TYPES, openModal } from '../../redux/actions/modalActions';
import VerificationRequiredContainer from '../VerificationRequired/VerificationRequiredContainer';
import store from '../../redux/store';
import { closeReportBlockTradeSidePane } from '../../redux/actions/sidePaneActions';
import { kycVerificationLevelsSelector } from '../../redux/selectors/kycLevelsSelectors';
import { positionSelector } from '../../redux/selectors/positionSelectors';
import { orderTotalSelector } from '../../redux/selectors/orderTotalSelector';
import { formatNumberToLocale } from '../../helpers/numberFormatter';
import { getOrderNet } from '../../helpers/orderHelper';
import config from '../../config';
var closeSidePane = function closeSidePane() {
  return store.dispatch(closeReportBlockTradeSidePane());
};
var mapStateToProps = function mapStateToProps(state, _ref) {
  var useNewForm = _ref.useNewForm;
  var form = state.form,
    product = state.apexCore.product;
  var decimalPlaces = product.decimalPlaces;
  var selectedInstrument = selectedInstrumentSelector(state);
  var _kycVerificationLevel = kycVerificationLevelsSelector(state),
    disableTrading = _kycVerificationLevel.disableTrading;
  var formObj = form.reportBlockTrade || {
    values: {}
  };
  var instruments = instrumentSelectorInstruments(state);
  var orderTotal = form.reportBlockTrade ? orderTotalSelector(state, {
    form: form.reportBlockTrade.values,
    useNewForm: useNewForm
  }) : 0;
  var orderNet = getOrderNet(formObj, selectedInstrument, orderTotal);
  return Object.assign({
    instruments: instruments,
    selectedInstrument: selectedInstrument,
    formObj: formObj,
    decimalPlaces: decimalPlaces
  }, instrumentPositionSelector(state), {
    positions: positionSelector(state),
    orderTotal: selectedInstrument.Product2Symbol + ' ' + formatNumberToLocale(orderTotal, selectedInstrument.Product2Symbol),
    orderNet: orderNet,
    initialValues: {
      useNewForm: useNewForm,
      side: formObj.values.side || buyValue,
      instrument: selectedInstrument.InstrumentId,
      quantity: '',
      fee: {
        OrderFee: '0'
      },
      totalAmount: '0',
      price: '',
      counterparty: '',
      orderType: orderTypes.reportBlockTrade.displayName,
      lockedIn: false
    },
    disableTrading: disableTrading,
    VerificationRequiredComponent: React.createElement(VerificationRequiredContainer, {
      onVerificationLinkClick: closeSidePane
    }),
    showLockedIn: config.BlockTrade.showLockedIn
  });
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var useNewForm = _ref2.useNewForm;
  return {
    onSubmit: function onSubmit() {
      return dispatch(openModal(MODAL_TYPES.CONFIRM_BLOCK_REPORT, {
        useNewForm: useNewForm
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'reportBlockTrade',
  enableReinitialize: true
})(ReportBlockTradeComponent));